<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des cartes</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>

        <!-- Alerte pour les notifications -->
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>

        <!-- Modal de modification -->
        <modal :adaptive="true"
               :height="'auto'"
               :clickToClose="false"
               :draggable="false"
               :resizable="false"
               name="modal-fade"
               style="max-height: 90vh; overflow-y: auto;">
          <v-card class="card-edit-card">
            <v-toolbar
                color="#01579B"
                dark
                flat>
              <v-text-field class="text--darken-3 mt-3 modal-title"
                            dense
                            hide-details
                            readonly
                            rounded
                            v-model="modifier">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                  @click="hide()"
                  dark
                  fab
                  small>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-alert :color="AlertColorS(typeS)"
                     :dismissible="true"
                     :value="true"
                     border="top"
                     class="pre-formatted multi-line ma-0"
                     colored-border
                     elevation="2"
                     icon="check_circle"
                     v-if="typeS">
              {{ text }}
            </v-alert>

            <v-card-text class="pb-0">
              <v-container class="pa-2">
                <v-card flat class="card-info-card pa-2">
                  <div class="card-info-header">
                    <v-chip color="primary" label small class="step-chip">
                      <v-icon small left>mdi-information-outline</v-icon>
                      Infos de la carte
                    </v-chip>
                  </div>

                  <!-- Informations carte -->
                  <v-row dense>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Identifiant carte</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          class="centered-input mb-2"
                          v-model="editedItem.identifiant">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Informations employé -->
                  <v-row dense>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Matricule</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          readonly
                          class="centered-input mb-2"
                          v-model="editedItem.matricule">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-1">
                      <label class="field-label">Nom du salarié</label>
                      <v-text-field
                          filled
                          dense
                          hide-details
                          readonly
                          class="centered-input mb-2"
                          v-model="editedItem.employeeName">
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <!-- Bouton activé/désactivé -->
                  <v-row dense class="mt-2">
                    <v-col cols="12" class="py-0">
                      <label class="field-label">Statut de la carte</label>
                      <v-radio-group
                          v-model="editedItem.statusCode"
                          row
                          dense
                          hide-details
                          @change="updateStatusFromCode">
                        <v-radio
                            color="success"
                            label="Carte active"
                            value="active">
                        </v-radio>
                        <v-radio
                            color="error"
                            label="Carte inactive"
                            value="disabled">
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-card>
              </v-container>
            </v-card-text>

            <v-card-actions class="justify-center pa-4">
              <v-btn @click="hide()" text class="mr-2">
                <v-icon left>mdi-close</v-icon>Annuler
              </v-btn>
              <v-btn
                  :disabled="!FormIsValidModif"
                  @click="updateCard()"
                  class="white--text"
                  color="#01579B"
                  depressed>
                <v-icon left>mdi-content-save</v-icon>Modifier carte
              </v-btn>
            </v-card-actions>
          </v-card>
        </modal>

        <v-card class="mt-1" flat tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export cartes</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" max-height="90vh" persistent v-model="dialog">
                <template v-slot:activator="{ on }">
                  <v-btn @click="init()" block class="custom-btn white--text" color="#009688" height="45px" large v-on="on">
                    <v-icon class="mr-1">mdi-credit-card-plus-outline</v-icon>
                    <span>Ajouter carte</span>
                  </v-btn>
                </template>
                <v-card class="card-edit-card">
                  <v-toolbar color="#01579B" dark flat>
                    <v-toolbar-title>Ajout carte</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" dark fab small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-alert :color="AlertColor(type)"
                           :dismissible="true"
                           :value="true"
                           border="top"
                           class="pre-formatted multi-line ma-0"
                           colored-border
                           elevation="2"
                           icon="check_circle"
                           v-if="type">
                    {{ text }}
                  </v-alert>

                  <v-card-text class="pb-0">
                    <v-container class="pa-2">
                      <v-card flat class="card-info-card pa-2">
                        <div class="card-info-header">
                          <v-chip color="primary" label small class="step-chip">
                            <v-icon small left>mdi-information-outline</v-icon>
                            Infos de la carte
                          </v-chip>
                        </div>

                        <!-- Identifiant de la carte -->
                        <v-row dense>
                          <v-col cols="12" class="py-1">
                            <label class="field-label">Identifiant de la carte</label>
                            <v-text-field
                                filled
                                dense
                                hide-details
                                v-model="editedItem.identifiant"
                                placeholder="Identifiant de la carte">
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Sélection de l'employé -->
                        <v-row dense>
                          <v-col cols="12" class="py-1">
                            <label class="field-label">Employé</label>
                            <v-autocomplete
                                filled
                                dense
                                hide-details
                                v-model="editedItem.employeeId"
                                :items="employees"
                                item-text="label"
                                item-value="id"
                                :loading="loadingEmployees"
                                @change="updateEmployeeSelection"
                                placeholder="Sélectionnez un employé">
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <!-- Statut de la carte avec radio buttons au lieu du switch -->
                        <v-row dense class="mt-2">
                          <v-col cols="12" class="py-0">
                            <label class="field-label">Statut de la carte</label>
                            <v-radio-group
                                v-model="editedItem.statusCode"
                                row
                                dense
                                hide-details
                                @change="updateStatusFromCode">
                              <v-radio
                                  color="success"
                                  label="Carte active"
                                  value="active">
                              </v-radio>
                              <v-radio
                                  color="error"
                                  label="Carte inactive"
                                  value="disabled">
                              </v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-container>
                  </v-card-text>

                  <v-card-actions class="justify-center pa-4">
                    <v-btn @click="close" text class="mr-2">
                      <v-icon left>mdi-close</v-icon>Annuler
                    </v-btn>
                    <v-btn
                        :disabled="!FormIsValid"
                        @click="createCard()"
                        class="white--text"
                        color="#01579B"
                        depressed>
                      <v-icon left>mdi-credit-card-plus</v-icon>Créer carte
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="mt-4" elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';
import Handsontable from 'handsontable';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "cards",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      loading: false,
      loading2: false,
      loadingEmployees: false,
      e6: 1,
      tab: null,
      dialog: false,
      assignDialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      modifier: "",
      typeS: null,
      type: null,
      elapse: null,
      errors: [],
      excelData: [],
      toObject: [],
      employees: [],
      originalCardsData: [], // Stocke les données originales des cartes
      selectedCard: null, // Stocke la carte sélectionnée pour l'assignation
      selectedEmployee: null, // Stocke l'employé sélectionné pour l'assignation
      editedItem: {
        id: "",
        identifiant: "",
        employeeId: null,
        matricule: "",
        employeeName: "",
        companyName: "",
        disabled: false,
        creationDate: ""
      },
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            modifier: {
              name: "Modifier",
              callback: this.modifierCallback // Reference to method
            },
            sp1: '---------',
            // Commenté: Option d'assignation dans le menu contextuel
            /*
            assign: {
              name: "Assigner à un employé",
              callback: this.assignCallback // Reference to method
            },
            unassign: {
              name: "Désassigner de l'employé",
              callback: this.unassignCallback // Reference to method
            },
            */
            sp2: '---------',
            remove_row: {
              name: "Supprimer"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Identifiant carte", "Nom entreprise", "Nom salarié", "Matricule salarié", "Statut", "Date création"
        ],
        columns: [
          {title: "Id", width: "10px", readOnly: true},
          {title: "Identifiant carte", width: "100px"},
          {title: "Nom entreprise", width: "100px", readOnly: true},
          {title: "Nom salarié", width: "100px", readOnly: true},
          {title: "Matricule salarié", width: "130px", readOnly: true},
          {title: "Statut", width: "70px", type: "text", readOnly: true, renderer: "statusRenderer"},
          {title: "Date création", width: "100px", align: "center", type: "date", readOnly: true}
        ]
      }
    }
  },

  created() {
    // Enregistrer le renderer personnalisé pour le statut
    Handsontable.renderers.registerRenderer('statusRenderer', this.statusRenderer);

    this.getData();

    this.hotSettings.contextMenu.items.modifier.callback =
        this.hotSettings.contextMenu.items.modifier.callback.bind(this);

    // Commenté: Binding des callbacks d'assignation/désassignation
    /*
    this.hotSettings.contextMenu.items.assign.callback =
        this.hotSettings.contextMenu.items.assign.callback.bind(this);

    this.hotSettings.contextMenu.items.unassign.callback =
        this.hotSettings.contextMenu.items.unassign.callback.bind(this);
    */
  },

  mounted() {
    // Ces lignes ne sont plus nécessaires car nous utilisons
    // une approche différente pour le menu contextuel
    // window.show = this.show;
    // window.displayTitleModif = this.displayTitleModif;
    // window.updateData4Modif = this.updateData4Modif;
    // window.showAssignModal = this.showAssignModal;
    // window.unassignCardRow = this.unassignCardRow;
  },

  computed: {
    FormIsValid() {
      console.log("Checking form validity:", {
        employeeId: this.editedItem.employeeId,
        identifiant: this.editedItem.identifiant
      });

      return (
          this.editedItem.employeeId !== null &&
          this.editedItem.employeeId !== undefined &&
          this.editedItem.identifiant !== ""
      );
    },
    FormIsValidModif() {
      return (
          this.editedItem.id !== "" &&
          this.editedItem.identifiant !== ""
      );
    }
  },

  watch: {
    employees: {
      handler(newVal) {
        console.log("Watch triggered: employees changed", newVal.length);
      },
      deep: true
    }
  },

  methods: {
    // Rendu personnalisé pour la colonne Statut
    statusRenderer(instance, td, row, col, prop, value, cellProperties) {
      // D'abord appliquer le renderer par défaut pour nettoyer
      Handsontable.renderers.TextRenderer.apply(this, arguments);

      // Ensuite, styliser en fonction de la valeur
      if (value === 'Active') {
        td.innerHTML = '<span style="color: #4CAF50; font-weight: bold;">' + value + '</span>';
      } else {
        td.innerHTML = '<span style="color: #F44336; font-weight: bold;">' + value + '</span>';
      }

      // Centrer le texte
      td.style.textAlign = 'center';
    },

    modifierCallback(key, selection) {
      let start = selection[0].start;
      let row = start.row;
      this.displayTitleModif(row);
      this.updateData4Modif(row);
      this.show();
    },

    // Commenté: Méthode de callback pour l'assignation
    /*
    assignCallback(key, selection) {
      let start = selection[0].start;
      let row = start.row;
      this.showAssignModal(row);
    },
    */

    // Commenté: Méthode de callback pour la désassignation
    /*
    unassignCallback(key, selection) {
      let start = selection[0].start;
      let row = start.row;
      this.unassignCardRow(row);
    },
    */

    // Commenté: Méthode d'affichage du modal d'assignation
    /*
    // ASSIGNMENT MODAL METHOD
    showAssignModal(row) {
      const rowData = this.$refs.hotTable.hotInstance.getSourceDataAtRow(row);
      const cardId = rowData[0];

      // Get the selected card details
      const card = this.originalCardsData.find(c => c.id === cardId);

      if (card) {
        this.selectedCard = card;

        // If card is already assigned
        if (card.employee && card.employee.id) {
          this.text = `Cette carte est déjà assignée à ${card.employee.accountLastname} ${card.employee.accountFirstname} (${card.employee.userId}).`;
          this.color = "#F44336";
          this.showAlert('warning');
          return;
        }

        // Open assignment modal
        this.assignDialog = true;

        // Load employees if not already loaded
        if (this.employees.length === 0) {
          this.loadEmployeesAndCompanies();
        }
      } else {
        this.text = "Impossible de trouver les détails de cette carte.";
        this.color = "#F44336";
        this.showAlert('warning');
      }
    },
    */

    // Commenté: Méthodes de confirmation d'assignation
    /*
    confirmAssignation() {
      if (!this.selectedCard || !this.selectedEmployee) {
        this.text = "Veuillez sélectionner un employé.";
        this.color = "#F44336";
        this.showAlert('warning');
        return;
      }
      this.assignCardToEmployee(this.selectedCard, this.selectedEmployee);
      this.assignDialog = false;
      this.selectedCard = null;
      this.selectedEmployee = null;
    },
    */

    // Commenté: Méthode de désassignation de carte
    /*
    unassignCardRow(row) {
      console.log("unassignCardRow called with row:", row);

      try {
        const rowData = this.$refs.hotTable.hotInstance.getSourceDataAtRow(row);
        console.log("Row data:", rowData);

        const cardId = rowData[0];
        console.log("Card ID:", cardId);

        // Get the selected card details
        const card = this.originalCardsData.find(c => c.id === cardId);
        console.log("Found card:", card);

        if (card) {
          // Check if card is assigned
          if (!card.employee || !card.employee.id) {
            this.text = "Cette carte n'est assignée à aucun employé.";
            this.color = "#F44336";
            this.showAlert('warning');
            return;
          }

          // Call unassign method
          this.unassignCard(card);
        } else {
          this.text = "Impossible de trouver les détails de cette carte.";
          this.color = "#F44336";
          this.showAlert('warning');
        }
      } catch (error) {
        console.error("Error in unassignCardRow:", error);
        this.text = "Une erreur s'est produite lors de la désassignation de la carte.";
        this.color = "#F44336";
        this.showAlert('warning');
      }
    },
    */

    // Commenté: Dialogue de confirmation de désassignation
    /*
    // UNASSIGN CONFIRMATION DIALOG
    unassignCard(card) {
      if (!card || !card.identifiant) {
        this.text = "Veuillez sélectionner une carte valide.";
        this.color = "#F44336";
        this.showAlert('warning');
        return;
      }

      this.$dialog
          .confirm({
            title: 'Confirmation',
            body: `Voulez-vous vraiment désassigner cette carte de l'employé ?`
          })
          .then(dialog => {
            this.loading = true;

            const baseUrl = this.$store.getters.user.baseUrl;
            const identifiant = card.identifiant;
            const sender_id = sessionStorage.getItem("accountId");

            apiClient
                .post(`${baseUrl}/wallet/unassign_wallet_card/${identifiant}/${sender_id}`)
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message || "Carte désassignée avec succès.";
                    this.showAlert('info');
                    this.getData(); // Refresh data
                  } else {
                    this.color = "#F44336";
                    this.text = res.data.message || "Erreur lors de la désassignation de la carte.";
                    this.showAlert('warning');
                  }
                })
                .catch(err => {
                  dialog.close();
                  this.loading = false;
                  this.color = "#F44336";
                  this.text = err.response?.data?.message || "Erreur lors de la désassignation de la carte.";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // User cancelled
          });
    },
    */

    displayTitleModif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.modifier = "Modification carte de " + rowT[3];
    },

    updateData4Modif(row) {
      let rowT = this.$refs.hotTable.hotInstance.getData()[row];
      this.editedItem.id = rowT[0];
      this.editedItem.identifiant = rowT[1];
      this.editedItem.companyName = rowT[2];
      this.editedItem.employeeName = rowT[3];
      this.editedItem.matricule = rowT[4];

      // Mettre à jour disabled basé sur le texte du statut
      this.editedItem.disabled = rowT[5] === 'Inactive';

      // Mettre à jour le statut en fonction de disabled
      this.editedItem.statusCode = this.editedItem.disabled ? "disabled" : "active";
      this.editedItem.creationDate = rowT[6];
    },

    updateEmployeeSelection(selectedId) {
      console.log("Selected employee ID:", selectedId);

      if (selectedId) {
        // Find the employee by ID
        const employee = this.employees.find(e => e.id === selectedId);

        if (employee) {
          this.editedItem.matricule = employee.userId || '';
          this.editedItem.employeeName = (employee.accountLastname || '').toUpperCase() + " " +
              this.capitalizeFirstLetters(employee.accountFirstname || '');

          console.log("Updated employee info:", {
            matricule: this.editedItem.matricule,
            employeeName: this.editedItem.employeeName
          });
        }
      }
    },

    capitalizeFirstLetters(str) {
      if (!str) return '';
      return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    },

    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },

    cleared() {
      this.searchName = "";
      this.getData();
    },

    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase();

      if (this.isEmpty(query)) {
        this.cleared();
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },

    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },

    hide() {
      this.$modal.hide('modal-fade');
    },

    loadEmployeesAndCompanies() {
      this.loadingEmployees = true;

      console.log("1. Starting loadEmployeesAndCompanies");
      console.log("2. baseUrl:", this.$store.getters.user.baseUrl);

      // Utiliser l'ID stocké dans sessionStorage comme dans Wallets.vue
      const userId = sessionStorage.getItem("userId");
      console.log("3. userId:", userId);

      // Construire l'URL avec l'ID du compte comme dans Wallets.vue
      const employeeUrl = `${this.$store.getters.user.baseUrl}/account/users/${userId}`;
      console.log("4. Employee URL:", employeeUrl);

      apiClient
          .get(employeeUrl)
          .then(response => {
            console.log("5. Received employee response");
            this.loadingEmployees = false;

            if (response.data && response.data.status === 200) {
              console.log("6. Response status is 200");

              // Check if datas array exists and has items
              if (response.data.datas && Array.isArray(response.data.datas) && response.data.datas.length > 0) {
                console.log("7. Found", response.data.datas.length, "employees in response");

                // Map to a simpler structure that matches what the autocomplete needs
                this.employees = response.data.datas.map(employee => {
                  const mappedEmployee = {
                    id: employee.id,
                    userId: employee.userId || '',
                    accountFirstname: employee.accountFirstname || '',
                    accountLastname: employee.accountLastname || '',
                    label: ((employee.accountLastname || '').toUpperCase() + " " +
                        this.capitalizeFirstLetters(employee.accountFirstname || '') +
                        (employee.userId ? " (" + employee.userId + ")" : ""))
                  };

                  return mappedEmployee;
                });

                console.log("8. Mapped employees (first 3):", this.employees.slice(0, 3));

                // Force reactivity by setting a new array
                this.$set(this, 'employees', [...this.employees]);
              } else {
                console.warn("7b. No employee data in response:", response.data);
                this.employees = [];
              }
            } else {
              console.error("6b. Invalid response:", response.data);
              this.employees = [];
            }
          })
          .catch(error => {
            console.error("5b. Error fetching employees:", error);
            this.loadingEmployees = false;
            this.employees = [];
          });
    },

    initEditedItem() {
      this.editedItem = {
        id: "",
        identifiant: "",
        employeeId: null,
        matricule: "",
        employeeName: "",
        companyName: "",
        disabled: false,
        statusCode: "active", // Nouveau champ pour les radio buttons
        creationDate: ""
      };
    },

    // Fonction pour mettre à jour la propriété disabled en fonction du statut sélectionné
    updateStatusFromCode() {
      // Si statusCode est "disabled", alors disabled = true
      // Si statusCode est "active", alors disabled = false
      this.editedItem.disabled = (this.editedItem.statusCode === "disabled");
    },

    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render();
    },

    getData() {
      this.loading = true;

      // Utiliser l'accountId stocké dans sessionStorage
      const accountId = sessionStorage.getItem("accountId");
      console.log("Getting cards with accountId:", accountId);

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_cards/${accountId}`
          )
          .then(response => {
            this.loading = false;
            console.log("Card data response:", response.data);

            if (response.data && response.data.status === 200 && Array.isArray(response.data.datas)) {
              let tabArray = [];
              let newObj = response.data.datas;

              // Stocker les données originales pour pouvoir y accéder lors des opérations (désassigner, etc.)
              this.originalCardsData = newObj;

              String.prototype.capitalize = function (allWords) {
                return (allWords) ? // if all words
                    this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                    this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
              }

              newObj.forEach((item) => {
                tabArray.push([
                  item["id"],
                  item["identifiant"],
                  item["walletCompany"]?.name.toUpperCase() || 'N/A',
                  item["employee"]?.accountLastname.toUpperCase() + " " + (item["employee"]?.accountFirstname.toLowerCase().capitalize(true) || ''),
                  item["employee"]?.userId || 'N/A',
                  // Afficher le statut en texte
                  item["disabled"] ? 'Inactive' : 'Active',
                  this.datefull(item["creationDate"])
                ]);
              });

              this.$refs.hotTable.hotInstance.loadData(tabArray);
              this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
            } else {
              console.warn("Invalid or empty card data:", response.data);
              this.$refs.hotTable.hotInstance.loadData([]);
              this.toObject = [this.hotSettings.colHeaders];
            }
          })
          .catch((error) => {
            console.error("Error fetching card data:", error);
            this.loading = false;
            this.$refs.hotTable.hotInstance.loadData([]);
            this.toObject = [this.hotSettings.colHeaders];
          });
    },

    onCancel() {
      this.loading = false;
    },

    refresh() {
      this.getData();
    },

    datefull(val) {
      if (!val) {
        return;
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },

    close() {
      this.dialog = false;
      this.initEditedItem();
    },

    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlert(type) {
      this.type = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    AlertColorS(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },

    showAlertS(type) {
      this.typeS = type;

      let timer = this.showAlert.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.typeS === "info") {
          this.hide();
        }
        this.typeS = null;
      }, 20000);

      this.elapse = 1;
      let t = this.showAlert.t;
      if (t) {
        clearInterval(t);
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0;
          clearInterval(this.showAlert.t);
        } else {
          this.elapse++;
        }
      }, 5000);
    },

    dismissible_close() {
      this.elapse = 3;
      clearTimeout(this.showAlert.timer);
      clearInterval(this.showAlert.t);
      this.type = null;
    },

    onexport() {
      this.loading = true;
      // export json to Worksheet of Excel
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true});

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      XLSX.utils.book_append_sheet(wb, datas, "Cartes");

      // export Excel file
      XLSX.writeFile(wb, "Cartes.xlsx");
      this.loading = false;
    },

    // Création d'une nouvelle carte
    createCard() {
      if (!this.FormIsValid) {
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const identifiant = this.editedItem.identifiant;
      const account_id = this.editedItem.employeeId;
      const sender_id = sessionStorage.getItem("accountId");

      // Utiliser l'endpoint correct pour ajouter une carte
      const url = `${baseUrl}/wallet/add_wallet_card/${identifiant}/${account_id}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.dialog = false;
              this.getData();
              this.initEditedItem();
              this.showAlert('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning');
            }
          })
          .catch(err => {
            this.text = err;
            this.dialog = false;
            this.loading = false;
            this.color = "#F44336";
            this.showAlert('warning');
          });
    },

    // Commenté: Méthode d'assignation de carte à un employé
    /*
    // Assignation d'une carte à un employé par son matricule
    assignCardToEmployee(card, employee) {
      // Vérifier que les paramètres sont valides
      if (!card || !card.identifiant || !employee || !employee.userId) {
        this.text = "Veuillez sélectionner une carte et un employé valides.";
        this.color = "#F44336";
        this.showAlert('warning');
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const identifiant = card.identifiant;
      const userId = employee.userId;
      const sender_id = sessionStorage.getItem("accountId");

      // Utiliser le nouvel endpoint direct qui ne nécessite pas d'objet JSON dans le corps
      apiClient
          .post(
              `${baseUrl}/wallet/assign_wallet_card_to_matricule_direct/${identifiant}/${userId}/${sender_id}`
          )
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message || `Carte assignée avec succès à ${employee.accountLastname} ${employee.accountFirstname}`;
              this.showAlert('info');
              this.getData(); // Rafraîchir les données
            } else {
              this.color = "#F44336";
              this.text = res.data.message || "Erreur lors de l'assignation de la carte.";
              this.showAlert('warning');
            }
          })
          .catch(err => {
            this.loading = false;
            this.color = "#F44336";
            this.text = err.response?.data?.message || "Erreur lors de l'assignation de la carte.";
            this.showAlert('warning');
          });
    },
    */

    // Commenté: Méthode de désassignation de carte
    /*
    // Désassignation d'une carte
    unassignCard(card) {
      // Vérifier que la carte est valide
      if (!card || !card.identifiant) {
        this.text = "Veuillez sélectionner une carte valide.";
        this.color = "#F44336";
        this.showAlert('warning');
        return;
      }

      // Confirmer avant de désassigner
      this.$dialog
          .confirm({
            title: 'Confirmation',
            body: `Voulez-vous vraiment désassigner cette carte de l'employé ?`
          })
          .then(dialog => {
            this.loading = true;

            const baseUrl = this.$store.getters.user.baseUrl;
            const identifiant = card.identifiant;
            const sender_id = sessionStorage.getItem("accountId");

            // Appeler l'API pour désassigner la carte
            apiClient
                .post(
                    `${baseUrl}/wallet/unassign_wallet_card/${identifiant}/${sender_id}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message || "Carte désassignée avec succès.";
                    this.showAlert('info');
                    this.getData(); // Rafraîchir les données
                  } else {
                    this.color = "#F44336";
                    this.text = res.data.message || "Erreur lors de la désassignation de la carte.";
                    this.showAlert('warning');
                  }
                })
                .catch(err => {
                  dialog.close();
                  this.loading = false;
                  this.color = "#F44336";
                  this.text = err.response?.data?.message || "Erreur lors de la désassignation de la carte.";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // L'utilisateur a annulé, ne rien faire
          });
    },
    */

    // Mise à jour d'une carte existante
    updateCard() {
      if (!this.FormIsValidModif) {
        return;
      }

      this.loading = true;

      const baseUrl = this.$store.getters.user.baseUrl;
      const wallet_card_id = this.editedItem.id;
      const identifiant = this.editedItem.identifiant;
      const disabled = this.editedItem.disabled;
      const sender_id = sessionStorage.getItem("accountId");

      // Construction de l'URL avec les paramètres corrects selon l'endpoint spécifié
      const url = `${baseUrl}/wallet/update_wallet_card/${wallet_card_id}/${identifiant}/${disabled}/${sender_id}`;

      apiClient
          .post(url)
          .then(res => {
            this.loading = false;
            if (res.data.status === 200) {
              this.color = "#009688";
              this.text = res.data.message;
              this.hide();
              this.getData();
              this.initEditedItem();
              this.showAlertS('info');
            } else {
              this.color = "#F44336";
              this.text = res.data.message;
              this.showAlertS('warning');
            }
          })
          .catch(err => {
            this.text = err;
            this.loading = false;
            this.color = "#F44336";
            this.showAlertS('warning');
          });
    },

    // Gestion des modifications directes dans le tableau
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de la carte.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true;
              const row = changes[0][0];
              const col = changes[0][1];
              const newValue = changes[0][3];

              let obj = this.$refs.hotTable.hotInstance.getData()[row];

              const wallet_card_id = obj[0];
              let identifiant = obj[1];
              // Adapter la logique de statut pour le texte "Active" ou "Inactive"
              let disabled = obj[5] === 'Inactive';

              // Mettre à jour la valeur modifiée
              if (col === 1) { // Identifiant carte
                identifiant = newValue;
              } else if (col === 5) { // Statut (texte)
                disabled = newValue === 'Inactive';
              }

              const baseUrl = this.$store.getters.user.baseUrl;
              const sender_id = sessionStorage.getItem("accountId");

              // Construction de l'URL avec les paramètres corrects
              const url = `${baseUrl}/wallet/update_wallet_card/${wallet_card_id}/${identifiant}/${disabled}/${sender_id}`;

              apiClient
                  .post(url)
                  .then(res => {
                    dialog.close();
                    this.loading = false;
                    if (res.data.status === 200) {
                      this.color = "#009688";
                      this.text = res.data.message;
                      this.showAlert('info');
                      this.getData();
                    } else {
                      this.color = "#F44336";
                      this.text = res.data.message;

                      // Restaurer la valeur précédente
                      let myData = this.$refs.hotTable.hotInstance.getData();
                      myData[row][col] = changes[0][2];
                      this.$refs.hotTable.hotInstance.loadData(myData);

                      this.showAlert('warning');
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    dialog.close();

                    // Restaurer la valeur précédente
                    let myData = this.$refs.hotTable.hotInstance.getData();
                    myData[row][col] = changes[0][2];
                    this.$refs.hotTable.hotInstance.loadData(myData);

                    this.color = "#F44336";
                    this.text = err.data ? err.data.message : err;
                    this.showAlert('warning');
                  });
            })
            .catch(() => {
              this.loading = false;
              // Restaurer la valeur précédente
              let myData = this.$refs.hotTable.hotInstance.getData();
              myData[changes[0][0]][changes[0][1]] = changes[0][2];
              this.$refs.hotTable.hotInstance.loadData(myData);
            });
      }
    },

    // Gestion de la suppression d'une ligne
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index];
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de la carte.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            // Récupérer l'ID de la carte à supprimer
            const wallet_card_id = rowId[0];
            const sender_id = sessionStorage.getItem("accountId");

            // Utiliser le bon endpoint pour la suppression
            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_card_by_id/${wallet_card_id}/${sender_id}`
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    this.color = "#009688";
                    this.text = res.data.message;
                    this.showAlert('info');
                  } else {
                    // Restaurer la ligne
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.color = "#F44336";
                    this.text = res.data.message;
                    this.showAlert('warning');
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;

                  // Restaurer la ligne
                  this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
                  this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                  this.color = "#F44336";
                  this.text = error;
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // Restaurer la ligne
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index);
            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);
          });
    },

    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
    },

    adjustDialogHeight() {
      // Déterminer si nous sommes sur un appareil mobile
      const isMobile = window.innerWidth < 600;

      // Définir la hauteur maximale pour le dialogue principal et modal
      const maxHeight = isMobile ? '100vh' : '90vh';

      // Appliquer aux éléments du DOM
      const dialogs = document.querySelectorAll('.v-dialog');
      dialogs.forEach(dialog => {
        dialog.style.maxHeight = maxHeight;
      });

      // Pour les modals (si vous utilisez vue-js-modal)
      const modalContainer = document.querySelector('.v--modal-overlay .v--modal-box');
      if (modalContainer) {
        modalContainer.style.maxHeight = maxHeight;
        modalContainer.style.height = 'auto';
        modalContainer.style.overflowY = 'auto';
      }
    },

    show() {
      this.$modal.show('modal-fade');

      // Ajuster la hauteur du modal après son ouverture
      this.$nextTick(() => {
        // Sélectionnez le conteneur modal
        const modalContainer = document.querySelector('.v--modal-overlay .v--modal-box');
        if (modalContainer) {
          // Définir une hauteur maximale en pixels (équivalent à 90vh)
          const viewportHeight = window.innerHeight;
          const maxHeightInPixels = Math.floor(viewportHeight * 0.9);

          // Appliquer la hauteur maximale en pixels
          modalContainer.style.maxHeight = maxHeightInPixels + 'px';
          modalContainer.style.height = 'auto';
          modalContainer.style.overflowY = 'auto';
        }
      });
    },

    adjustModalHeight() {
      const viewportHeight = window.innerHeight;
      const maxHeightInPixels = Math.floor(viewportHeight * 0.9);
      const modalContainer = document.querySelector('.v--modal-overlay .v--modal-box');

      if (modalContainer) {
        modalContainer.style.maxHeight = maxHeightInPixels + 'px';
      }
    },

    init() {
      this.tab = "tab-1";
      this.file = "";
      this.initEditedItem();
      this.loadEmployeesAndCompanies();
      this.$nextTick(() => {
        this.adjustDialogHeight();
      });
    }
  }
};
</script>

<style scoped>
/* =====================
   Styles de base
   ===================== */
.toolbar .v-toolbar__content {
  padding: 0 !important;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent;
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

/* =====================
   Tableaux HandsOnTable
   ===================== */
.area.highlight,
.htCenter.htMiddle.highlight {
  background-color: #d0e1ef !important;
}

/* =====================
   Formulaires et champs
   ===================== */
/* Texte centré dans les inputs */
.centered-input >>> input {
  text-align: center !important;
}

/* Styles pour les sélecteurs */
.v-select__selections {
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

.v-select__selection {
  margin: 0 !important;
  text-align: center !important;
}

.v-select .v-select__selection--comma {
  margin: 0 auto !important;
  text-align: center !important;
  width: 100% !important;
  overflow: visible !important;
}

.v-select .v-input__slot div {
  text-align: center !important;
}

/* Switch d'activation */
.v-input--selection-controls__input {
  margin: 0 auto !important;
}

/* =====================
   Modales et dialogues
   ===================== */
/* Carte de modification */
.card-edit-card {
  border-radius: 8px;
  overflow: hidden;
}

.card-edit-card .v-toolbar {
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Titre de la modale */
.modal-title .v-input__slot {
  margin-bottom: 0 !important;
  padding: 0 12px !important;
  background-color: rgba(255, 255, 255, 0.15) !important;
}

/* Contenu scrollable */
.v-dialog .v-card-text,
.modal .v-card-text {
  max-height: calc(90vh - 120px);
  overflow-y: auto;
}

.v-dialog .v-card-actions,
.modal .v-card-actions {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 1;
  padding: 16px !important;
}

/* Carte d'information */
.card-info-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fcfcfc;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.card-info-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.card-info-header {
  margin-bottom: 16px;
}

/* Puce d'étape */
.step-chip {
  border-radius: 16px;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

/* Labels de champs */
.field-label {
  display: block;
  font-size: 12px;
  color: #757575;
  margin-bottom: 4px;
  font-weight: 500;
  transition: color 0.2s ease;
}

.v-text-field:hover .field-label,
.v-select:hover .field-label {
  color: #01579B;
}

/* Champs de texte et sélecteurs */
.v-text-field.v-text-field--filled > .v-input__control > .v-input__slot,
.v-select.v-select--filled > .v-input__control > .v-input__slot {
  background-color: #f5f5f5 !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.v-text-field:hover .v-input__slot,
.v-select:hover .v-input__slot {
  background-color: #f0f0f0 !important;
  transition: background-color 0.2s ease;
}

/* Champs désactivés */
.v-text-field.v-text-field--is-disabled .v-input__slot {
  opacity: 0.8;
  background-color: #f8f8f8 !important;
}

/* Employé selection */
.employee-selection {
  font-weight: 500;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-autocomplete.v-select {
  border-radius: 4px;
}

.v-autocomplete.v-select .v-select__selections input {
  padding: 0 8px;
}

/* Style pour le switch activé/désactivé */
.v-switch .v-input--selection-controls__input {
  margin-right: 8px;
}

.v-switch .v-label {
  font-weight: 500;
}

.v-switch.v-input--is-label-active .v-label {
  color: #4CAF50;
}

.v-switch:not(.v-input--is-label-active) .v-label,
.v-input--switch:not(.v-input--is-dirty) .v-label {
  color: #F44336 !important;
}

.v-input--switch.v-input--is-dirty .v-label {
  color: #4CAF50 !important;
}

/* =====================
   Boutons et actions
   ===================== */
.v-card-actions .v-btn {
  min-width: 120px;
  margin: 0 8px;
}

.v-card-actions .v-btn.v-btn--depressed.white--text {
  box-shadow: 0 2px 4px rgba(1, 87, 155, 0.2) !important;
  transition: all 0.2s ease;
}

.v-card-actions .v-btn.v-btn--depressed.white--text:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(1, 87, 155, 0.25) !important;
}

.v-card-actions .v-btn.v-btn--depressed.white--text:active {
  transform: translateY(1px);
  box-shadow: 0 1px 3px rgba(1, 87, 155, 0.3) !important;
}

/* =====================
   Vue-js-modal styles
   ===================== */
.v--modal {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px !important;
  overflow: hidden !important;
}

.v--modal-overlay {
  background: rgba(0, 0, 0, 0.5) !important;
}

/* =====================
   Responsive styles
   ===================== */
@media (max-width: 600px) {
  .card-edit-card {
    border-radius: 0;
  }

  .v--modal {
    border-radius: 0 !important;
    width: 100% !important;
    left: 0 !important;
  }

  .v-dialog,
  .v--modal {
    margin: 0 !important;
    border-radius: 0 !important;
  }

  .v-card-actions {
    flex-wrap: wrap;
    justify-content: center;
  }

  .v-card-actions .v-btn {
    margin: 4px;
    flex-grow: 1;
  }
}
</style>